import React from 'react';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
	checkUpdates, collaboratorsPageNumber,
	flash,
	getChangedStatus, getSharingDetailsPopup, ownershipChangeTarget,
	putUpdateCollaborators, updateCollaborators, updatingCollaborators
} from '../../../../../../../../../../../../../actions/sharingDetailsActions';
import {
    getSelectedContactsGroup,
				labelStateUpdating
} from '../../../../../../../../../../../../../actions/contactsGroupItemActions';
import Icon from "../../../../../../../../../../../../components/icon";
import Button from "../../../../../../../../../../../../components/button";

class SaveChanges extends React.Component {

	constructor(props){
		super(props);

		this.saveChange = this.saveChange.bind(this);
		this.cancelChange = this.cancelChange.bind(this);
	}

	collaboratorHideAnimation(){

		if(document.querySelectorAll('.collaborators > div').length > 0){

			document.querySelectorAll('.collaborators > div.is-deleting').forEach((item, index) => {
				if(item.classList.contains('disappearing') === false){
					setTimeout(() => {
						item.classList.remove('py-2');
						item.classList.add('disappearing', 'py-0');
					}, 100 + index * 50);
				}
			});

		}

	}

	saveChange(){

		if(this.props.sharingDetailsPopup[2]){
			this.props.labelStateUpdating(this.props.sharingDetailsPopup[2]);
		} else {
			this.props.labelStateUpdating(this.props.selectedContactsGroup.id);
		}

		this.props.setUpdatingCollaborators(true);

        if(this.props.ownershipChangeTarget === null) {
            this.collaboratorHideAnimation();
        }

		let toDelete = false;

		if(this.props.updateCollaborators.length > 0){
			const checkPermissionOfOwner = this.props.updateCollaborators.find((arr) => arr.permission === "OWNER");
			if(!checkPermissionOfOwner) {

				this.props.updateCollaborators.forEach((item) => {
					if(item.toRemove){
						toDelete = true;
					}
				});

				if(toDelete){

					/*
					* Waiting of the collaborator delete animation
					* */

					setTimeout(() => {
						this.props.putUpdateCollaborators({
							collaborators: this.props.updateCollaborators
						});
					}, 200);

				} else {
					this.props.putUpdateCollaborators({
						collaborators: this.props.updateCollaborators
					});
				}

			} else {

				//this.props.getSharingDetailsPopup([]);

				if(this.props.ownershipChangeTarget){
					this.props.getSharingDetailsPopup([]);
					setTimeout(() => {
						this.props.getSharingDetailsPopup([true, "transfer_ownership"]);
					}, 500)
				} else {
					this.props.putUpdateCollaborators({
						collaborators: this.props.updateCollaborators
					});
				}

			}
		}
	}

	cancelChange(){

        this.props.getSharingDetailsPopup([]);

		this.props.getChangedStatus(false);
		this.props.setUpdateCollaborators([]);
		this.props.setFlash([]);
		this.props.setOwnershipChangeTarget(null);
		this.props.checkUpdates();

		if(this.props.collaboratorsPageNumber > 1){
			this.props.setCollaboratorsPageNumber(1)
		}

	}

	render(){
		return (
			<div className="options-wrapper">
                <div className="options d-flex align-items-center justify-content-end collapsed">
					<div className={`btn-wrapper`}>
						{
							!this.props.updatingCollaborators
							&& <Button className="btn-outline-primary" onClick={this.cancelChange}>
								{this.props.t("textCancel")}
							</Button>
						}
						<Button
							className="ml-2 btn-primary"
							onClick={this.saveChange}
							disabled={this.props.updatingCollaborators}
						>
							{
								this.props.updatingCollaborators
								?
									<Icon animated={'pulse'} name="spinner"/>
								:
								this.props.t("textSave")
							}
						</Button>
					</div>
                </div>
			</div>
		);
	}

}

const mapStateToProps = (state) => {
	return {
		selectedContactsGroup : state.contactsGroupItemReducer.getSelectedContactsGroup,
		deletedCollaborators : state.sharingDetailsReducer.getDeletedCollaborators,
		updateCollaborators : state.sharingDetailsReducer.updateCollaborators,
		ownershipChangeTarget : state.sharingDetailsReducer.ownershipChangeTarget,
        profile: state.profileReducer.getProfile,
        isSyncing : state.syncStatusReducer.isSyncing,
        collaboratorsPageNumber : state.sharingDetailsReducer.collaboratorsPageNumber,
		updatingCollaborators : state.sharingDetailsReducer.updatingCollaborators,
		sharingDetailsPopup : state.sharingDetailsReducer.getSharingDetailsPopup
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getSelectedContactsGroup : (object) => {
			dispatch(getSelectedContactsGroup(object))
		},
		putUpdateCollaborators : (boolean) => {
			dispatch(putUpdateCollaborators(boolean))
		},
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
		getChangedStatus : (boolean) => {
			dispatch(getChangedStatus(boolean))
		},
		setUpdateCollaborators : (array) => {
			dispatch(updateCollaborators(array))
		},
        checkUpdates : () => {
            dispatch(checkUpdates())
        },
		setFlash : (array) => {
			dispatch(flash(array))
		},
		setOwnershipChangeTarget : (string) => {
			dispatch(ownershipChangeTarget(string))
		},
        setCollaboratorsPageNumber : (int) => {
            dispatch(collaboratorsPageNumber(int))
        },
		labelStateUpdating: (labelId) => {
            dispatch(labelStateUpdating(labelId))
        },
		setUpdatingCollaborators: (boolean) => {
			dispatch(updatingCollaborators(boolean))
		},
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SaveChanges));
